import { useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";

import { TenantIdContext } from "@touchtech/web-tenant-id-provider";

import { TranslationContext } from "@is/constants";
import { useTenant } from "@is/hooks";

type Props = {
  onClick?: () => void;
};
function useManageLogo({ onClick }: Props) {
  const { t } = useTranslation(TranslationContext.General);

  const [tenantId] = useContext(TenantIdContext);

  const { tenant } = useTenant(tenantId);

  const handleClick = useCallback(() => {
    onClick && onClick();
  }, [onClick]);

  return { t, tenant, handleClick };
}

export default useManageLogo;
